import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoAlertaGrupo } from '../_models/producto-alerta-grupo';

@Injectable({
  providedIn: 'root'
})
export class ProductoAlertaGrupoService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosAlertasGrupos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoAlertaGrupo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoAlertaGrupo[] ) );
  }

  listadoHabilitadosPorIdProductoAlerta(idProductoAlerta:string) {
    return this.httClient.get( this.rutServicio + '/productoAlerta/' + idProductoAlerta + '/enabled' ).pipe( map( res => res as ProductoAlertaGrupo[] ) );
  }

  listadoPorIdProductoAlerta(idProductoAlerta:string) {
    return this.httClient.get( this.rutServicio + '/productoAlerta/' + idProductoAlerta ).pipe( map( res => res as ProductoAlertaGrupo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoAlertaGrupo ) );
  }

  obtenerPorIdProductoAlertaYCodigo(idProductoAlerta: string, codigo: string) {
    return this.httClient.get( this.rutServicio + '/productoAlerta/' + idProductoAlerta + '/codigo/' + codigo + '/' ).pipe( map( res => res as ProductoAlertaGrupo ) );
  }

  crear( regCrear: ProductoAlertaGrupo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoAlertaGrupo ) );
  }

  actualizar( regActualizar: ProductoAlertaGrupo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductoAlertaGrupo ) );
  }

  inhabilitarAlertaGrupo(idProductoAlertaGrupo:string){
    return this.httClient.get( this.rutServicio + '/deshabilitarCondiciones/' + idProductoAlertaGrupo).pipe( map( res => res as ProductoAlertaGrupo ) );

  }
}
